import { pipe, map } from "rxjs"
import { User } from "src/app/core/models/user/user.model"
import { UserSummaryDto } from "src/app/infrastructure/lobby-proxy/DTOs/user.dto"

export const mapUserSummaryDtoToUser = pipe(
    map((source: UserSummaryDto) => userSummaryDtoToUser(source))
)

export function userSummaryDtoToUser(source: UserSummaryDto): User | null {
    if (!source) return null
    return {
        id: source.userId,
        name: source.nome,
        surname: source.cognome,
        displayName: source.displayName ?? `${source.nome} ${source.cognome} (${source.userId})`,
    } as User
}